import { Quaternion, Scene, Vector3 } from "three";
import { IPresetAnimation, IPresetAnimationOptionUnion, ITuple3, ITuple4 } from "../component-data-structure";
import { IEasingTypes } from "../transitions";

export const getThreePropertyFromOptions = (options: IPresetAnimationOptionUnion): 'rotation' | 'position' | 'scale' | null => {
	switch (options.entityAnimation) {
		case IPresetAnimation.move:
			return 'position';
		case IPresetAnimation.scale:
			return 'scale';
		case IPresetAnimation.spin:
			return 'rotation';
		default:
			return null;
	}
};

export const validateAnimationOptions = (options: IPresetAnimationOptionUnion) => {
	if (!options) return false;
	return !!Object.entries(options).filter(([key, value]) => typeof value === 'undefined' || (key !== 'loopCount' && value === null)).length;
};

export const createAnimationSettingsFromOptions = (options: IPresetAnimationOptionUnion) => {
	switch (options.entityAnimation) {
		case IPresetAnimation.move:
		case IPresetAnimation.scale:
			return {
				from: 0,
				to: 1,
				duration: options.duration,
				delay: options.delay,
				loopCount: options.loopCount,
				easing: options.easing as any as IEasingTypes,
				backAndForth: options.backAndForth,
				resetOnFinish: options.resetOnFinish,
			};
		case IPresetAnimation.orbit:
		case IPresetAnimation.spin:
		default:
			return {
				from: 0,
				to: 1,
				duration: options.duration,
				delay: options.delay,
				loopCount: options.loopCount,
				easing: options.easing as any as IEasingTypes,
				backAndForth: options.backAndForth,
			};
	}
};

export const rotateAroundWorldAxis = (reusableQuaternion: Quaternion, pivot: Vector3, quaternion: Quaternion, position: Vector3, axis: Vector3, radians: number, isOffset: boolean, rotateObject: boolean) => {
	// rotate object around axis in world space (the axis passes through point)
	// axis is assumed to be normalized
	// assumes object does not have a rotated parent

	const q1 = reusableQuaternion.setFromAxisAngle(axis, radians);

	const _position = isOffset ? pivot.clone().add(position) : position.clone();
	const _quaternion = quaternion.clone();
	const q2 = rotateObject ? _quaternion.multiplyQuaternions(q1, quaternion) : _quaternion;

	_quaternion.set(...(q2.toArray() as ITuple4));

	_position.sub(pivot).applyQuaternion(q1).add(pivot);

	return {
		quaternion: _quaternion,
		position: _position,
	};
};

export const resetToInitialThreeValues = (scene: Scene, targetIds: string[], initialValueArray: { position: ITuple3; scale: ITuple3; rotation: ITuple3 }[]) => {
	for (let i = 0; i < targetIds.length; i++) {
		const targetId = targetIds[i];
		const threeEntity = scene.getObjectByName(targetId);
		const initialValues = initialValueArray[i];
		threeEntity?.position?.set(...initialValues['position']);
		threeEntity?.children[0]?.scale?.set(1, 1, 1);
		threeEntity?.rotation?.set(...initialValues['rotation']);
	}
};

// export const getOldTransformsArray = (options: IPresetAnimationOptionUnion, scene: Scene) => {
//     options.targetIds.map((id, i) => {
//         const threeEntity = transformInnerGroup ? scene.getObjectByName(`inner_${id}`) : scene.getObjectByName(id);
//         const { position: _position } = initialTransformValuesArray[i];
//         let position = new Vector3(..._position);

//         if (options.entityAnimation === IPresetAnimation.orbit) {
//             if (positionIsOffset) {
//                 pivot = scene.getObjectByName(options.pivot as string)!.position;
//                 position = position.sub(pivot);
//             } else {
//                 pivot = new Vector3(...(options.pivot as ITuple3));
//             }
//         }

//         return {
//             position,
//             scale: new Vector3(1, 1, 1),
//             rotation: new Euler(0, 0, 0),
//             quaternion: threeEntity!.quaternion.clone(),
//         };
//     });
// }